import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CCInputModule } from '@maids/cc-lib/input';
import { CCButtonModule } from '@maids/cc-lib/button';
import { CCCardModule } from '@maids/cc-lib/card';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CCIconModule } from '@maids/cc-lib/icon';
import { CCErpAuthModule } from '@maids/cc-erp-services';
import { NewLoginComponent } from './components/new-login/new-login.component';
@NgModule({
  declarations: [LoginComponent, NewLoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    CCInputModule,
    CCButtonModule,
    CCCardModule,
    CCIconModule,
    CCErpAuthModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  exports: [LoginComponent, NewLoginComponent],
  // todo: this should be determined based on the theme
  // providers: [
  //   {
  //     provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
  //     useValue: { appearance: 'outline' },
  //   },
  // ],
})
export class CoreModule {}
